

import React, { Fragment } from 'react';
import privacyPolicyData from './policy_data';
import styles from "./policy_info_section.module.css"
const PrivacyPolicy = () => {
  const { title, lastUpdate, intro, dataProcessorController, purposeLawfulBasis, dataRetention, recipientsOfData, technicalMeasures, contact, socialMedia, yourRights, contactDetails, modificationPolicy } = privacyPolicyData;

  return (
    <div>
      <h1 className={styles.heading}>{title}</h1>
      <p>{lastUpdate}</p>

      <section>
        <h2 className={styles.title}>Introduction</h2>
        <p>{intro}</p>
      </section>

      <section>
        <h2 className={styles.title}>Data Processor - Data Controller</h2>
        <p>{dataProcessorController}</p>
      </section>

      <section>
        <h2 className={styles.title}>{privacyPolicyData.dataYouMayShare.title}</h2>
        <p>{privacyPolicyData.dataYouMayShare.content}</p>
        <table>
          <tbody>
            {privacyPolicyData.dataYouMayShare.table.rows.map((row, index) => (
              <tr key={index}>
                <td>{row.category}</td>
                <td>{row.fields}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p>{privacyPolicyData.dataYouMayShare.content_end}</p>
      </section>

      {/* <section>
        <h2 className={styles.title}>{privacyPolicyData.dataWeCollect.title}</h2>
        <p>{privacyPolicyData.dataWeCollect.content}</p>
        <table>
          <tbody>
            {privacyPolicyData.dataWeCollect.table.rows.map((row, index) => (
              <tr key={index}>
                <td>{row.category}</td>
                <td>{row.fields}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section> */}
      
      {/* <section>
        <h2 className={styles.title}>Your Rights</h2>
        <table>
          <thead>
            <tr>
              <th>Right</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {yourRights.map((right, index) => (
              <tr key={index}>
                <td>{right.name}</td>
                <td>{right.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section> */}
      <section>
        <h2 className={styles.title}>Purpose & Lawful Basis for Personal Data Processing</h2>
        <ul>
          {purposeLawfulBasis.map((item, index) => (
            <Fragment key={index}>
            <p>{item.startContent}</p>
            <li key={index}>
              <strong>Purpose:  </strong> {item.purpose}
              <br />
              <strong>Lawful Basis:  </strong> {item.lawfulBasis}
            </li>
            <p>{item.endContent}</p>
            </Fragment>
          ))}
        </ul>
      </section>

      <section>
        <h2 className={styles.title}>Data Retention</h2>
        <p>{dataRetention}</p>
      </section>

      <section>
        <h2 className={styles.title}>Recipients of Data</h2>
        <p>{recipientsOfData}</p>
      </section>

      <section>
        <h2 className={styles.title}>Technical Measures of the Platform</h2>
        <p>{technicalMeasures}</p>
      </section>

      <section>
        <h2 className={styles.title}>Contact the Platform</h2>
        <p>{contact}</p>
      </section>

      <section>
        <h2 className={styles.title}>Social Media</h2>
        <p>{socialMedia}</p>
      </section>

      <section>
        <h2 className={styles.title}>Your Rights</h2>
        <table>
         
          <tbody>
            {yourRights.map((right, index) => (
              <tr key={index}>
                <td>{right.name}</td>
                <td>{right.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h2 className={styles.title}>Contact Details</h2>
        <p>{contactDetails}</p>
      </section>

      <section>
        <h2 className={styles.title}>Modification of this Privacy Policy</h2>
        <p>{modificationPolicy}</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
